import { render, staticRenderFns } from "./OrderReceivingCodePrint.vue?vue&type=template&id=4b320628&scoped=true&"
import script from "./OrderReceivingCodePrint.vue?vue&type=script&lang=js&"
export * from "./OrderReceivingCodePrint.vue?vue&type=script&lang=js&"
import style0 from "./OrderReceivingCodePrint.vue?vue&type=style&index=0&id=4b320628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b320628",
  null
  
)

export default component.exports